import { FC } from "react";

type BadgeVariant = "gray" | "teal" | "red";

interface TredingStockCardBadgeProps {
  children: React.ReactNode;
  variant?: BadgeVariant;
}

const TredingStockCardBadge: FC<TredingStockCardBadgeProps> = ({ children, variant = "gray" }) => {
  const styles: Record<BadgeVariant, string> = {
    gray: "bg-[#F2F2F2] text-[#666666]",
    teal: "bg-[#CCEFF480] text-[#008094]",
    red: "bg-[#B400001A] text-[#B40000]",
  };

  return (
    <span
      className={`rounded-[2px] px-1 py-0.5 text-[8px] md:text-[10px] font-medium uppercase tracking-wide ${styles[variant]}`}
    >
      {children}
    </span>
  );
};

export default TredingStockCardBadge;